/**
 * Environment-aware logging utility.
 * Silences debug logs during tests to reduce noise in test output.
 */

const isTest = import.meta.env.VITEST === 'true' || import.meta.env.MODE === 'test';
const isProduction = import.meta.env.PROD;
const shouldLog = !isTest && !isProduction;

/**
 * Log a debug message to the console, except during tests.
 * Use this for development debugging that shouldn't appear in test output.
 */
export const devLog = (...args: unknown[]): void => {
  if (shouldLog) console.log(...args);
};

/**
 * Log a warning to the console, except during tests.
 * Use this for development warnings that shouldn't appear in test output.
 */
export const devWarn = (...args: unknown[]): void => {
  if (shouldLog) console.warn(...args);
};

/**
 * Log an error to the console, except during tests.
 * Note: For true errors that should always be logged, use console.error directly.
 */
export const devError = (...args: unknown[]): void => {
  if (shouldLog) console.error(...args);
};
